module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "portalink.b7627d08.gif";